import { default as index4PZzyyUOK2Meta } from "/app/dev/pages/index.vue?macro=true";
import { default as component_45stubc9b3bdHtLLMeta } from "/app/dev/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubc9b3bdHtLL } from "/app/dev/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index___en",
    path: "/",
    component: () => import("/app/dev/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/app/dev/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/app/dev/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/app/dev/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___it",
    path: "/it",
    component: () => import("/app/dev/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___pl",
    path: "/pl",
    component: () => import("/app/dev/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___pt",
    path: "/pt",
    component: () => import("/app/dev/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___ru",
    path: "/ru",
    component: () => import("/app/dev/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___uk",
    path: "/uk",
    component: () => import("/app/dev/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___ja",
    path: "/ja",
    component: () => import("/app/dev/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___ko",
    path: "/ko",
    component: () => import("/app/dev/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___zh",
    path: "/zh",
    component: () => import("/app/dev/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___ar",
    path: "/ar",
    component: () => import("/app/dev/pages/index.vue").then(m => m.default || m)
  },
  {
    name: component_45stubc9b3bdHtLLMeta?.name,
    path: "/r",
    component: component_45stubc9b3bdHtLL
  },
  {
    name: component_45stubc9b3bdHtLLMeta?.name,
    path: "/en",
    component: component_45stubc9b3bdHtLL
  }
]